import axios from "axios";
import HandleLogout from "./logout";

const handleAxiosResponse = (response) => {
  if (response?.status === 401) {
    HandleLogout();
  }

  return response;
};

const resolveUrl = (endpoint) => {
  const base = (
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    "http://localhost:8000/"
  ).replace(/\/+$/, "");
  const path = (endpoint || "").replace(/^\/+/, "");
  return `${base}/${path}`;
};

export const AxiosGetMethod = async (endpoint, unauthorised) => {
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-entry-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  return await axios
    .get(resolveUrl(endpoint), {
      headers,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosPostMethod = async (
  endpoint,
  body,
  unauthorised,
  formData
) => {
  // body = await geturlsearchbody(body);
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-entry-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (formData) {
    headers = {
      ...headers,
      ...{
        "Content-Type": "multipart/form-data",
      },
    };
  }
  return await axios
    .post(resolveUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosPutMethod = async (endpoint, body, unauthorised) => {
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-entry-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  return await axios
    .put(resolveUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosDeleteMethod = async (endpoint, body) => {
  // body = await geturlsearchbody(body);
  const token = localStorage.getItem("dwt-entry-tok");
  return await axios
    .delete(resolveUrl(endpoint), {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};
